import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
export function ServicesPage() {
  return <main className="bg-white" data-id="element-558">
      <PageBanner title="Our Services" subtitle="Comprehensive fingerprinting solutions for every need, from employment to licensing." data-id="element-559" />
      <Services data-id="element-560" />
      <HowItWorks data-id="element-561" />
    </main>;
}